import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '#services';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/500', { queryParams: { returnUrl: state.url } }]);
    return false;
  }

  const account = authService.getAccount();
  const roles = authService.getRoles();

  if (roles.length > 1) {
    router.navigate(['/403'], {
      state: {
        message:
          'More than one role has been assigned. Please contact the administrator.',
      },
    });
    return false;
  }

  authService.setUserDetails({
    email: account?.username ?? '',
    username: account?.name ?? account?.username ?? '',
    role: roles[0] ?? '',
    isAdmin: authService.isAdmin(),
    hasAccess: roles.length > 0,
  });

  if (!('roles' in route.data)) {
    return true;
  }

  const isAuthorized = authService.isAuthorized(route.data['roles']);
  if (!isAuthorized) {
    router.navigate(['/403'], { state: { returnUrl: state.url } });
    return false;
  }

  return true;
};
